<template>
    <div class="productCenter">
        <!--顶部 start-->
        <div class="top_box">
            <p class="text_box ly_flex ly_flex_col ly_flex_ali_center ly_flex_just_center">
                <span>产品中心</span>
                <span>Product Center</span>
            </p>
        </div>
        <!--顶部 end-->

        <!--产品内容 start-->
        <div class="contentWidth product_content_box">
            <h2 class="product_title">产品中心</h2>
            <ul class="ly_flex ly_flex_wrap_wrap ly_flex_just_between">
                <li class="li_box" v-for="item in productList" :key="item.key">
                    <img class="li_img" :src="item.imgPath" alt="">
                    <h3 class="li_h3">{{item.title}}</h3>
                    <p class="li_p">{{item.content}}</p>
                </li>
            </ul>
        </div>
        <!--产品内容 end-->
    </div>
</template>

<script>
    export default {
        name: "productCenter",
        data(){
            return{
                productList:[
                    {
                        imgPath:require('@/assets/img/product1.png'),
                        title:'家庭医生签约服务管理平台',
                        content:'智徽家庭医生信息管理平台与互联网紧密结合，实现＂在线PC端软件+在线手机网软件+医生APP端+居民APP端+管理APP端＂全方位的系统覆盖，使家庭医生服务更加便捷；'
                    },
                    {
                        imgPath:require('@/assets/img/product2.png'),
                        title:'智徽健康APP居民端',
                        content:'智徽健康APP居民端是一款利用信息化与移动客户端平台搭建医生与居民的互动平台，为签约服务，健康咨询，慢病管理，健康知识宣教，健康管理等提供便利。'
                    },
                    {
                        imgPath:require('@/assets/img/product3.png'),
                        title:'智徽健康APP医护端',
                        content:'智徽健康医护端APP是专为基层医务人员打造的家庭医生服务管理软件，集在线签约，移动公位，医患互动，远程指导，精准健康教育，查询统计，团队协作等功能一体，提供高效，便捷的家庭医生服务管理工具。'
                    },
                    {
                        imgPath:require('@/assets/img/product4.png'),
                        title:'智徽健康APP监管端',
                        content:'对全省家医工作的组织管理情况、业务开展情况、业务开展效果、居民满意度情况、资金管理情况等进行实时、高效的动态监管；对地市家医工作进行客观、公正、高效的信息化考核评价；对全省家医工作进行合理、全面的数字化预测。'
                    },
                    // {
                    //     imgPath:require('@/assets/img//product5.png'),
                    //     title:'健康管理解决方案',
                    //     content:'智徽家庭医生信息管理平台与互联网紧密结合，实现＂在线PC端软件+在线手机网软件+医生APP端+居民APP端+管理APP端＂全方位的系统覆盖，使家庭医生服务更加便捷；'
                    // },
                    {
                        imgPath:require('@/assets/img/product6.png'),
                        title:'统一支付平台',
                        content:'支付平台根据统一服务接入、统一财务收银台、财务分级对账的原则建设。统一支付平台有效减轻财务对账的工作量，提高工作效率，改善现有就诊环境，给患者提供更便捷的就医体验，提升医院满意度。'
                    },
                    {
                        imgPath:require('@/assets/img/product7.png'),
                        title:'慢性病精细化管理平台',
                        content:'通过现代信息化的手段，建立全套生命周期的慢性病管理体系，规范慢性病管理流程，支撑医保付费方式改革，发挥医保基金门诊效应，提升义务人员诊疗服务效果，提升监管效率。'
                    },
                    {
                        imgPath:require('@/assets/img/product8.png'),
                        title:'医保医师考核评价平台',
                        content:'通过对医保数据进行全方位、多维度的综合分析，建立公平、合理、科学、有效的管理机制，引导医保医师自觉、主动规范医疗行为，提高服务质量，控制医疗费用不合理支出，确保医疗保险制度安全、健康的平稳运行，构建和谐共赢医、患、保关系。'
                    },
                    // {
                    //     imgPath:require('@/assets/img//product9.png'),
                    //     title:'智达版ZH-V501 全能机',
                    //     content:'自助建档、电子问卷、远程医疗、肺功能、电子视力、尿液分析、血脂四项、糖化血红蛋白、体温枪、身高、体重、BMI、腰臀比、脉率、血压、血糖、血氧、尿酸、总胆固醇、人体代谢率、水分含量、脂肪含量、12导心电、全程人机交互菜单指引 。'
                    // },
                    // {
                    //     imgPath:require('@/assets/img//product10.png'),
                    //     title:'智尊版ZH-300H',
                    //     content:'可以测量身高、体重、BMI、腰臀比、脉率、血压、血糖、血氧、尿酸、总胆固醇、人体代谢率、水分含量、脂肪含量、12导心电、全程人机交互菜单指引。'
                    // },
                    // {
                    //     imgPath:require('@/assets/img//product11.png'),
                    //     title:'5G/互联网 健康快车-K301',
                    //     content:'一站式体验，智能数据服务，签约获得感。'
                    // },
                    // {
                    //     imgPath:require('@/assets/img//product12.png'),
                    //     title:'智检箱ZH-',
                    //     content:'家庭医生随访箱集成了血压计、血糖仪、尿酸、尿液分析、体温、心电工作站、身份识别等设备，可实现健康档案建立与更新、健康体检、随访管理等一系列健康管理服务，并支持4G、wifi网 络通讯等多种模式。'
                    // },
                ]
            }
        }
    }
</script>

<style scoped lang="scss">
    .productCenter {
        .top_box {
            width: 100%;
            height: 306px;
            background: url("../../../public/img/corporateCultur/corporateCultureBanner.png");
            background-size: 100% 100%;

            .text_box {
                height: 100%;
                color: #ffffff;

                span:first-child {
                    font-size: 60px;
                    line-height: 60px;
                    font-weight: 600;
                }

                span:last-child {
                    margin-top: 36px;
                    font-size: 24px;
                    line-height: 24px;
                }
            }
        }

        .product_content_box {
            padding:117px 0 107px;
            .product_title {
                margin-bottom:  81px;
                text-align: center;
                font-size: 40px;
                line-height: 40px;
                font-weight: 600;
                color: #343434;
            }

            .li_box {
                box-sizing: border-box;
                margin-bottom: 28px;
                width: 377px;
                height: 480px;
                border: 1px solid #CBCBCB;
                .li_img{
                    display: block;
                    width: 374px;
                    height: 286px;
                }
                .li_h3{
                    margin-top:15px;
                    text-align: center;
                    font-size: 18px;
                    line-height: 18px;
                    font-weight: 600;
                    color: #343434;
                }
                .li_p{
                    padding:0 30px 0 25px;
                    margin-top:10px;
                    font-size: 14px;
                    line-height: 24px;
                    color:#444444;
                }
            }
        }
    }
</style>
